import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { BasePage } from '../../../shared/components/base-page.component';
import { UrlHelper } from '../../../shared/helpers/UrlHelper';
import { PlanHelper } from '../../../shared/Plan/Helpers/PlanHelper';
import { SiteListForUserApi } from '../../../shared/Site/ListForUser/Api/SiteListForUserApi';
import { CreateSubscriptionApi } from '../Apis/CreateSubscriptionApi';
import { CreateSubscriptionApiRequest } from '../Apis/Request/CreateSubscriptionApiRequest';
import { SubscribeModel } from './Models/SubscribeModel';
import { DropDownComponent } from '../../../shared/components/dropdown/DropDownComponent';

@Component({
    selector: 'subscribe-page',
    standalone: true,
    imports: [DropDownComponent, ...BasePage.BaseImports],
    templateUrl: './SubscribePage.html',
    styleUrl: './SubscribePage.css',
})

export class SubscribePage implements BasePage, OnInit
{
    public model$ = new BehaviorSubject<SubscribeModel | null>(null);
    public error$ = new BehaviorSubject<string | null>(null);
    public loading$ = new BehaviorSubject(false);
    public dashboardUrl = '';

    constructor(private route: ActivatedRoute, private createSubscriptionApi: CreateSubscriptionApi, private siteListForUserApi: SiteListForUserApi)
    {
        this.dashboardUrl = UrlHelper.AppBaseUrl;
    }

    async ngOnInit()
    {
        const sites = await this.siteListForUserApi.Get();

        const planSlug = this.route.snapshot.paramMap.get('plan') ?? 'starter';

        const upgradableSites = sites.Items.filter(i => !i.HasActiveSubscription);

        const siteId = upgradableSites.length ? upgradableSites[0].Id : null;

        const model: SubscribeModel = {
            SiteId: siteId,
            PlanId: PlanHelper.GetPlanId(planSlug)!,
            PlanSlug: planSlug,
            PlanName: PlanHelper.GetPlanDisplayName(planSlug),
            PlanMessagesPerMonth: PlanHelper.GetPlanMessagesPerMonth(planSlug),
            HasSites: sites.Items.length > 0,
            HasUpgradableSites: upgradableSites.length > 0,
            SiteSelectItems: upgradableSites.map(i => ({
                value: i.Id!,
                label: i.Name!,
                iconUrl: null
            })),
            CanSubscribe: upgradableSites.length > 0
        };

        this.model$.next(model);
    }

    async submit(form: NgForm)
    {
        if (form.invalid)
        {
            console.log('invalid form');
            form.control.markAllAsTouched(); // show validation errors
            return;
        }

        const model = this.model$.getValue();

        if (!model)
        {
            this.error$.next('Internal page data inconsistent. Please refresh the page.');
            return;
        }

        if (!model.SiteId)
        {
            this.error$.next('Please select a site.');
            return;
        }

        const request: CreateSubscriptionApiRequest =
        {
            SiteId: model.SiteId,
            PlanId: model.PlanId
        };

        this.loading$.next(true);
        this.error$.next(null);
        try
        {
            const checkoutUrl = await this.createSubscriptionApi.PostAsync(request);

            window.location.href = checkoutUrl;
        }
        catch (err: any)
        {
            this.error$.next(err);
            this.loading$.next(false);
        }
    }
}
